/* ZCT_V22_KOPF (E1): Verhalten der Seitenhülle wie in v21, gleiche Klassen, Schwellen und Takte.
   - zct-ankuendigung (JS-003): nächster Text alle 3,8 s, harter Tausch ohne Überblenden.
   - zct-kopf (JS-004 bis JS-009): Kopfleiste nav-clear / nav-liquid / nav-pdp (scrollY > 20, ZEN-Raum unter der
     Leiste, Produktbild hinter der Leiste bis 768 px), Logo-Wechsel, Prüfung bei scroll, resize und alle 350 ms;
     --nav-h beim Start, bei resize und alle 500 ms; Overlay-Menü mit Unterpanels und Kollektions-Ausklapper;
     Suche mit Produktliste aus #zct-produkte; Escape schließt Suche und Menü; Body-Sperre solange Menü oder Suche offen;
     seit „Bewegung komplett“ (14.10.2026) springt die Seite beim Öffnen des Menüs nicht mehr nach oben (Leseposition bleibt). Sprachwahl seit v25: Liste (ZCT_V25_SPRACHWAHL).
   Bewegung macht ausschließlich das vorhandene CSS (Klassen wie in v21).
   Seit Louis' Handy-Figma (14.10.2026): bis 1023 px weiße feste Leiste (kein nav-clear/nav-pdp mehr), Menü mit Unterseite Räume und
   Behind-Bildkarten, Hinweis „geht seitlich weiter“ für Handy-Leiste und Karten. */
(function () {
  'use strict';
  // Bewegung komplett: Zeit-Token lesen; Shopify liefert das CSS verkleinert aus (200ms wird .2s), daher Sekunden und Millisekunden
  function zdZeit(v) { v = String(v || '').trim(); var x = parseFloat(v); if (isNaN(x)) return NaN; return /ms$/i.test(v) ? x : (/s$/i.test(v) ? x * 1000 : x); }

  var ROOT = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');
  function texte() { var el = document.getElementById('zct-texte'); try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; } }
  var TEXTE = texte();
  function entschluesseln(s) { if (typeof s !== 'string' || s.indexOf('&') < 0) return s; var t = document.createElement('textarea'); t.innerHTML = s; return t.value; }
  function tx(k) { return TEXTE[k] != null ? entschluesseln(TEXTE[k]) : k; }
  // Bewegung komplett (Plan 003): Fenster nicht hart entfernen, sondern mit der Klasse zd-schliesst ausblenden (CSS in zct-v26.css) und danach entfernen
  function zdMs(n, f) { var v = zdZeit(getComputedStyle(document.documentElement).getPropertyValue(n)); return isNaN(v) ? f : v; }
  function wegBlenden(el) { if (!el) return; el.classList.add('zd-schliesst'); setTimeout(function () { el.remove(); }, zdMs('--zd-dauer-fenster-zu', 150) + 40); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  // ZCT_V25_SPRACHWAHL: Liste auf- und zuklappen (snippets/zct-sprachwahl.liquid). Links führen auf dieselbe Seite in der anderen
  // Sprache, die Abfrage (?…) bleibt. Unveröffentlichte Sprachen nur in der Theme-Vorschau (Shopify.theme.role ≠ main).
  function sprachListe(knopf, auf) {
    var box = knopf.closest('[data-zct-lang]'), liste = box && box.querySelector('ul');
    if (!liste) return;
    var offen = auf == null ? liste.hidden : auf;
    document.querySelectorAll('[data-zct-lang] ul').forEach(function (u) { if (u !== liste) { u.hidden = true; var k = u.parentNode.querySelector('.zct-lang-knopf'); if (k) k.setAttribute('aria-expanded', 'false'); } });
    liste.hidden = !offen; knopf.setAttribute('aria-expanded', offen ? 'true' : 'false');
  }
  function sprachListenZu(fokus) {
    document.querySelectorAll('[data-zct-lang] ul:not([hidden])').forEach(function (u) {
      u.hidden = true; var k = u.parentNode.querySelector('.zct-lang-knopf'); if (k) { k.setAttribute('aria-expanded', 'false'); if (fokus && u.contains(document.activeElement)) k.focus(); }
    });
  }
  (function vorschauSprachen() {
    var rolle = window.Shopify && Shopify.theme && Shopify.theme.role;
    if (!rolle || rolle === 'main') return;
    document.querySelectorAll('[data-zct-lang-vorschau]').forEach(function (li) {
      var a = li.querySelector('a[data-href]'); if (a) a.setAttribute('href', a.getAttribute('data-href')); li.hidden = false;
    });
  })();
  document.addEventListener('click', function (e) {
    var t = e.target, knopf = t.closest && t.closest('.zct-lang-knopf');
    if (knopf) { e.preventDefault(); e.stopPropagation(); sprachListe(knopf); return; }
    var link = t.closest && t.closest('.zct-lang-link[href]');
    if (link && location.search && !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)) { e.preventDefault(); location.href = link.getAttribute('href') + location.search; return; }
    if (!(t.closest && t.closest('[data-zct-lang]'))) sprachListenZu(false);
  }, true);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') sprachListenZu(true); });

  class ZctAnkuendigung extends HTMLElement {
    connectedCallback() {
      var daten = this.querySelector('script[type="application/json"]');
      var slide = this.querySelector('.ann .slide');
      var folien = [];
      try { folien = JSON.parse(daten.textContent); } catch (e) {}
      if (!slide || folien.length < 2) return;
      var i = 0, pause = false, self = this;
      var takt = Number(this.getAttribute('data-wechsel')) || 3800;
      // Bewegung komplett (Plan 010): alter Text blendet in --zd-dauer-fenster-zu aus (-4 px), neuer in --zd-dauer-aufklapper ein (+4 px -> 0),
      // --zd-kurve-aus; Pause, solange Maus oder Fokus auf der Leiste ist oder der Tab verdeckt ist (WCAG 2.2.2); „Bewegung reduzieren“: nur Deckkraft
      function wechseln() {
        if (pause || document.hidden || !slide.offsetParent) return; // am Handy ist die Leiste ausgeblendet
        i = (i + 1) % folien.length;
        var rs = getComputedStyle(document.documentElement), ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var kurve = (rs.getPropertyValue('--zd-kurve-aus') || '').trim() || 'ease-out', y = ruhig ? 0 : 4;
        if (!slide.animate) { slide.innerHTML = folien[i]; return; }
        var aus = slide.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateY(' + (-y) + 'px)' }], { duration: zdZeit(rs.getPropertyValue('--zd-dauer-fenster-zu')) || 150, easing: kurve, fill: 'forwards' });
        aus.onfinish = function () {
          slide.innerHTML = folien[i];
          var ein = slide.animate([{ opacity: 0, transform: 'translateY(' + y + 'px)' }, { opacity: 1, transform: 'none' }], { duration: zdZeit(rs.getPropertyValue('--zd-dauer-aufklapper')) || 200, easing: kurve });
          ein.onfinish = function () { aus.cancel(); };
        };
      }
      ['mouseenter', 'focusin'].forEach(function (t) { self.addEventListener(t, function () { pause = true; }); });
      ['mouseleave', 'focusout'].forEach(function (t) { self.addEventListener(t, function () { pause = false; }); });
      this.uhr = setInterval(wechseln, takt);
    }
    disconnectedCallback() { clearInterval(this.uhr); }
  }

  class ZctKopf extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.ab = new AbortController();
      var s = { signal: this.ab.signal };
      var nav = this.querySelector('nav.nav');
      var menue = this.querySelector('.overlay-menu');
      if (!nav || !menue) return;
      var knopf = nav.querySelector('.nav-menu-btn');
      var knopfText = knopf && knopf.querySelector('.nav-menu-label');
      var seite = document.body.getAttribute('data-page') || 'home';
      var zustand = { menue: false, suche: false, scrolled: false, zenroom: false, pdpHinter: true, kat: false, kol: false, navigiert: false };

      // ----- Kopfleiste (JS-004) -----
      // Seiten mit Titelbild ganz oben (body[data-zd-klar]): oben durchsichtig, nach dem Scrollen Glas; ein offener Ausklapper macht die
      // Leiste zu Glas. Die Suche lässt die Leiste, wie sie ist: sie liegt abgedunkelt darüber, eine weiß werdende Leiste blitzte sonst
      // als heller Streifen unter dem dunklen Banner durch. Übrige Seiten: weiße feste Leiste, nav-pdp nur ab 1024 px (wirkt dort nicht).
      // Startseite am Rechner: Liegt die ZEN-Bühne („Vier Objekte, ein Raum“) ganz unter der Leiste, wird die Leiste wieder durchsichtig
      // und das Bild füllt den ganzen Bildschirm (wie vor dem Redesign). Erst wenn die Bühne die Leiste ganz bedeckt, sonst stünde weiße
      // Schrift über dem hellen Abschnitt davor bzw. danach.
      function klassen() {
        var desktop = window.matchMedia('(min-width: 1024px)').matches;
        var klar = document.body.hasAttribute('data-zd-klar') && (!zustand.scrolled || zustand.zenroom) && !document.documentElement.classList.contains('zd-menue-offen');
        var k = 'nav' + (klar ? ' nav-clear' : '') + (zustand.scrolled && !klar ? ' nav-liquid' : '') + (desktop && seite === 'pdp' ? ' nav-pdp' : '');
        if (nav.className !== k) nav.className = k;
        menueKlassen();
      }
      function pruefen() {
        zustand.scrolled = window.scrollY > 20;
        zustand.zenroom = false;
        if (seite === 'home' && document.body.hasAttribute('data-zd-klar')) {
          var buehne = document.querySelector('.zenroom:not(.zenroom-hero)');
          if (buehne) { var r = buehne.getBoundingClientRect(); zustand.zenroom = r.top <= 2 && r.bottom > nav.getBoundingClientRect().bottom + 4; }
        }
        klassen();
      }
      // Teil C2: höchstens einmal pro Bild prüfen (requestAnimationFrame), ein Scroll-Listener statt zwei, kein Dauer-Timer mehr.
      // Ändert sich die Seitenhöhe (Bilder laden nach), meldet das der ResizeObserver.
      var geplant = false;
      function planen() { if (geplant) return; geplant = true; requestAnimationFrame(function () { geplant = false; pruefen(); }); }
      window.addEventListener('scroll', planen, { passive: true, signal: this.ab.signal });
      window.addEventListener('resize', planen, s);
      window.addEventListener('load', planen, s);
      if (window.ResizeObserver) { this.roSeite = new ResizeObserver(planen); this.roSeite.observe(document.body); }
      // Ausklapper auf/zu (zct-v26-menue.js setzt html.zd-menue-offen): Leiste sofort weiß bzw. wieder durchsichtig
      if (window.MutationObserver) {
        this.moKlar = new MutationObserver(planen);
        this.moKlar.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
        this.moKlar.observe(document.body, { attributes: true, attributeFilter: ['data-zd-klar'] });
      }
      else this.uhrPruefen = setInterval(pruefen, 350);

      // ----- --nav-h (JS-005) -----
      // Nur bei Änderung setzen: jede Änderung an <html> lässt den Browser die Stile der ganzen Seite neu prüfen
      var navHAlt = -1;
      function messen() { var h = nav.offsetHeight; if (h && h !== navHAlt) { navHAlt = h; document.documentElement.style.setProperty('--nav-h', h + 'px'); } }
      messen();
      window.addEventListener('resize', messen, s);
      if (window.ResizeObserver) { this.roNav = new ResizeObserver(messen); this.roNav.observe(nav); }
      else this.uhrMessen = setInterval(messen, 500);

      // ----- Overlay-Menü (JS-006 bis JS-008) -----
      var katPanel = this.querySelector('#om-categories-panel');
      var kolPanel = this.querySelector('#om-collections-panel');
      var katKnopf = this.querySelector('.om-link-cats');
      var kolKnopf = this.querySelector('.om-link-cols');
      // ZCT_V26: Zeile „Behind ZinCuTec“ im Handy-Menü mit eigenem Unterpanel (wie Kategorien); seit Louis' Handy-Figma (14.10.2026) stehen die
      // Behind-Seiten als Bildkarten im Menü und das Unterpanel heißt „Räume“ (Wohnzimmer, Esszimmer, Flur)
      var behPanel = this.querySelector('#om-behind-panel');
      var behKnopf = this.querySelector('.om-link-behind');
      var raePanel = this.querySelector('#om-raeume-panel');
      var raeKnopf = this.querySelector('.om-link-raeume');
      var flyoutVorlage = this.querySelector('template[data-zct-flyout]');
      var flyout = null;
      function menueKlassen() {
        var k = 'overlay-menu ' + (zustand.menue ? 'open' : '') + (zustand.scrolled && window.innerWidth > 768 ? ' scrolled' : '');
        if (menue.className !== k) menue.className = k;
      }
      function panels() {
        if (katPanel) katPanel.className = 'om-sub-panel' + (zustand.kat ? ' open' : '');
        if (kolPanel) kolPanel.className = 'om-sub-panel' + (zustand.kol ? ' open' : '');
        if (katKnopf) katKnopf.setAttribute('aria-expanded', String(zustand.kat));
        if (kolKnopf) kolKnopf.setAttribute('aria-expanded', String(zustand.kol));
        if (behPanel) behPanel.className = 'om-sub-panel' + (zustand.beh ? ' open' : '');
        if (behKnopf) behKnopf.setAttribute('aria-expanded', String(!!zustand.beh));
        if (raePanel) raePanel.className = 'om-sub-panel' + (zustand.rae ? ' open' : '');
        if (raeKnopf) raeKnopf.setAttribute('aria-expanded', String(!!zustand.rae));
        if (zustand.kol && kolPanel) zdBilder(kolPanel);
        if (zustand.beh && behPanel) zdBilder(behPanel);
        if (zustand.kol && !flyout && flyoutVorlage) {
          flyout = flyoutVorlage.content.firstElementChild.cloneNode(true);
          flyoutVorlage.after(flyout);
          flyout.addEventListener('click', function () { zustand.kol = false; panels(); });
          var innen = flyout.querySelector('.col-flyout-inner');
          if (innen) innen.addEventListener('click', function (e) { e.stopPropagation(); });
        } else if (!zustand.kol && flyout) { wegBlenden(flyout); flyout = null; }
      }
      // Bewegung komplett (Plan 001): Sperre auch an der Wurzel (iOS Safari), kein Sprung an den Seitenanfang mehr beim Öffnen des Menüs
      function ohneBewegung(fn) {
        var ps = menue.querySelectorAll('.om-sub-panel');
        ps.forEach(function (p) { p.style.transition = 'none'; });
        fn(); menue.getBoundingClientRect();
        ps.forEach(function (p) { p.style.removeProperty('transition'); });
      }
      function sperre() { var an = !!(zustand.menue || zustand.suche); document.body.style.overflow = an ? 'hidden' : ''; document.documentElement.classList.toggle('zd-gesperrt-menue', an); }
      // Bilder im Handy-Menü (Behind-Karten, Kollektionen) erst beim ersten Öffnen laden
      function zdBilder(wurzel) {
        wurzel.querySelectorAll('img[data-zd-src]').forEach(function (img) {
          if (img.getAttribute('data-zd-srcset')) img.setAttribute('srcset', img.getAttribute('data-zd-srcset'));
          img.setAttribute('src', img.getAttribute('data-zd-src'));
          img.removeAttribute('data-zd-src'); img.removeAttribute('data-zd-srcset');
        });
      }
      function bilderNeu(an) {
        menue.querySelectorAll('.om-product-img img[data-zct-src]').forEach(function (img) {
          if (an) { img.setAttribute('src', img.getAttribute('data-zct-src')); img.setAttribute('srcset', img.getAttribute('data-zct-srcset')); }
          else { img.removeAttribute('src'); img.removeAttribute('srcset'); }
        });
      }
      function menueSetzen(an) {
        zustand.menue = an;
        // Bewegung komplett (Plan 004): ein offenes Unterpanel fährt mit dem Menü hinaus und wird erst danach ohne Bewegung zurückgesetzt
        // (vorher fuhr es gleichzeitig gegenläufig zurück und die Hauptliste blitzte auf). Das Kollektions-Fenster am Tablet schließt sofort.
        clearTimeout(self.uhrPanels);
        if (!an) {
          if (flyout) { zustand.kol = false; panels(); }
          self.uhrPanels = setTimeout(function () { if (zustand.menue) return; zustand.kat = false; zustand.kol = false; zustand.beh = false; zustand.rae = false; ohneBewegung(function () { panels(); stufen2Zu(); }); }, zdMs('--zd-dauer-schublade-zu', 240) + 40);
        }
        // Kopf im Menü genau auf der Höhe der Zeile mit Logo und Symbolen: ganz oben unter dem Platz des Banners, nach dem Scrollen mit
        // der Luft über der Leiste; beim Öffnen springt so nichts nach oben (Wert für zct-v26-handy.css, .om-header)
        if (an) { var zeile = nav.querySelector('.nav-inner'); if (zeile) menue.style.setProperty('--om-oben', Math.max(0, Math.round(zeile.getBoundingClientRect().top)) + 'px'); }
        menueKlassen();
        if (an) {
          menue.style.transform = 'translateX(0)';
          menue.setAttribute('role', 'dialog'); menue.setAttribute('aria-modal', 'true');
          menue.removeAttribute('aria-hidden'); menue.removeAttribute('inert');
          // E7 (Fokus): Fokus auf „Schließen“ im Menü, beim Schließen zurück auf den Menüknopf (für Maus und Touch unsichtbar).
          // Das Menü blendet über visibility ein; im ersten Moment nimmt der Browser keinen Fokus an, daher kurz danach (und einmal nachfassen).
          [60, 400].forEach(function (ms) {
            setTimeout(function () { if (zustand.menue && zuKnopf && !menue.contains(document.activeElement)) zuKnopf.focus({ preventScroll: true }); }, ms);
          });
        } else {
          if (knopf && menue.contains(document.activeElement)) knopf.focus({ preventScroll: true });
          menue.style.removeProperty('transform'); if (!menue.getAttribute('style')) menue.removeAttribute('style');
          menue.removeAttribute('role'); menue.removeAttribute('aria-modal');
          menue.setAttribute('aria-hidden', 'true'); menue.setAttribute('inert', '');
        }
        if (knopf) { knopf.className = 'nav-menu-btn link' + (an ? ' active' : ''); knopf.setAttribute('aria-expanded', an ? 'true' : 'false'); }
        if (knopfText) knopfText.textContent = an ? tx('schliessen') : tx('menue');
        bilderNeu(an);
        sperre();
      }
      if (knopf) knopf.addEventListener('click', function () { menueSetzen(!zustand.menue); }, s);
      var zuKnopf = this.querySelector('[data-zct-menue-zu]');
      if (zuKnopf) zuKnopf.addEventListener('click', function () { menueSetzen(false); }, s);
      if (katKnopf) katKnopf.addEventListener('click', function () { if (!zustand.navigiert) { zustand.kat = true; panels(); } }, s);
      if (kolKnopf) kolKnopf.addEventListener('click', function () { if (!zustand.navigiert) { zustand.kol = true; panels(); } }, s);
      if (behKnopf) behKnopf.addEventListener('click', function () { if (!zustand.navigiert) { zustand.beh = true; panels(); } }, s);
      if (raeKnopf) raeKnopf.addEventListener('click', function () { if (!zustand.navigiert) { zustand.rae = true; panels(); } }, s);
      // Dritte Stufe (Auswahl mit Bild-Karte): liegt über der zweiten, „Zurück“ und Wischen nach rechts führen eine Stufe zurück
      var stufen2 = Array.prototype.slice.call(menue.querySelectorAll('[data-zd-stufe2]'));
      function stufen2Zu() { stufen2.forEach(function (p) { p.classList.remove('open'); }); }
      // Bewegung komplett (Plan 004): Wischen zum Schließen – Handy-Menü nach links, Unterpanels nach rechts (= zurück); Hilfe in zct-laden.js
      if (window.zctWischZu) {
        window.zctWischZu(menue, { richtung: 'links', offen: function () { return zustand.menue && window.innerWidth <= 768; }, zu: function () { menueSetzen(false); } });
        [[katPanel, 'kat'], [kolPanel, 'kol'], [behPanel, 'beh'], [raePanel, 'rae']].forEach(function (x) {
          if (x[0]) window.zctWischZu(x[0], { richtung: 'rechts', offen: function () { return zustand.menue && !!zustand[x[1]] && window.innerWidth <= 1023; }, zu: function () { zustand[x[1]] = false; panels(); } });
        });
        stufen2.forEach(function (p) {
          window.zctWischZu(p, { richtung: 'rechts', offen: function () { return zustand.menue && p.classList.contains('open') && window.innerWidth <= 1023; }, zu: function () { p.classList.remove('open'); } });
        });
      }
      menue.addEventListener('click', function (e) {
        var t = e.target;
        var stufe = t.closest('[data-zd-stufe-auf]');
        if (stufe) { var ziel = menue.querySelector('#' + stufe.getAttribute('data-zd-stufe-auf')); if (ziel) { zdBilder(ziel); ziel.classList.add('open'); } return; }
        if (t.closest('.om-sub-back')) {
          var p = t.closest('.om-sub-panel');
          if (p && p.hasAttribute('data-zd-stufe2')) { p.classList.remove('open'); return; }
          if (p === katPanel) zustand.kat = false; else if (p === behPanel) zustand.beh = false; else if (p === raePanel) zustand.rae = false; else zustand.kol = false;
          panels(); return;
        }
        if (t.closest('.om-sub-close')) { menueSetzen(false); return; }
        if (t.closest('.om-search')) { menueSetzen(false); sucheSetzen(true); return; }
        // Menülinks: wie nav() in v21 Menü schließen, 400 ms keine Unterpanels; die Seite lädt dann neu
        var a = t.closest('a[href]');
        if (a && !a.target && !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) && e.button === 0) {
          zustand.navigiert = true; zustand.kat = false; zustand.kol = false; zustand.beh = false; zustand.rae = false; panels(); stufen2Zu(); menueSetzen(false);
          setTimeout(function () { zustand.navigiert = false; }, 400);
        }
      }, s);

      // ----- Suche (JS-009) -----
      var sucheVorlage = this.querySelector('template[data-zct-suche]');
      var ebene = null;
      var produkte = (window.zctLaden && window.zctLaden.produkte) || [];
      var fmt = (window.zctLaden && window.zctLaden.fmt) || function (n) { return String(n); };
      function seitenTreffer(term) {
        var liste = [
          { id: 'zen', name: tx('v25_zen_kollektion'), keys: 'zen kollektion collection colección collezione', href: '/collections/zen' },
          { id: 'tukkon-col', name: tx('v25_tukkon_kollektion'), keys: 'tukkon kollektion collection colección collezione', href: '/collections/tukkon' },
          { id: 'bestseller-col', name: 'Bestseller', keys: 'bestseller best seller zen taisho kinko kollektion collection colección collezione más vendidos più venduti meilleures ventes', href: '/collections/bestseller' },
          { id: 'gift', name: tx('geschenkgutschein'), keys: 'gutschein geschenk gift voucher geschenkgutschein carte cadeau bon tarjeta regalo buono regalo', href: '/products/gift-card' },
          { id: 'blog', name: 'Blog', keys: 'blog journal werkstatt workshop stories atelier taller laboratorio', href: '/blogs/news' },
          { id: 'about', name: tx('ueber_uns_seite'), keys: 'über uns about werkstatt workshop team à propos équipe sobre nosotros equipo chi siamo', href: '/pages/about' },
          { id: 'care', name: tx('pflege_seite'), keys: 'pflege care gewährleistung statutory warranty patina oberfläche surface entretien garantie patine cuidado garantía pátina superficie cura garanzia', href: '/pages/pflege' },
          { id: 'b2b', name: tx('b2b'), keys: 'b2b wholesale business programm revendeur professionnel distribuidor rivenditore', href: '/pages/b2b' }
        ];
        return liste.filter(function (p) { return p.keys.indexOf(term) >= 0 || p.name.toLowerCase().indexOf(term) >= 0; });
      }
      function pfeil() { return '<svg class="ico " viewBox="0 0 16 16"><path d="M3 8h10m-4-4l4 4-4 4"></path></svg>'; }
      function trefferZeichnen(q) {
        if (!ebene) return;
        var koerper = ebene.querySelector('.search-body');
        var term = q.trim().toLowerCase();
        if (!term) { koerper.innerHTML = ebene._leer; return; }
        var ergebnisse = produkte.filter(function (p) {
          var heu = [p.name, p.id, p.kat, (p.toene || []).join(' '), p.monoDe, p.descDe, p.taglineDe].filter(Boolean).join(' ').toLowerCase();
          return heu.indexOf(term) >= 0;
        }).slice(0, 8);
        var seiten = seitenTreffer(term);
        var h = '';
        if (!ergebnisse.length && !seiten.length) {
          h += '<div class="search-empty"><div style="padding: 40px 0px; text-align: center; color: var(--ink-2);">' + esc(tx('keine_treffer_vor') + q + tx('keine_treffer_nach')) +
            '<br><span style="font-size: 13px; color: var(--ink-3);">' + esc(tx('versuche')) + '</span></div></div>';
        }
        if (seiten.length) {
          h += '<div class="search-results"><div class="search-eyebrow">' + esc(tx('seiten')) + '</div>';
          seiten.forEach(function (p) {
            h += '<a href="' + esc(ROOT + p.href) + '" class="search-row"><div class="search-thumb" style="background: var(--paper-3); display: flex; align-items: center; justify-content: center;">' + pfeil() +
              '</div><div class="search-meta"><div class="search-name">' + esc(p.name) + '</div></div>' + pfeil() + '</a>';
          });
          h += '</div>';
        }
        if (ergebnisse.length) {
          h += '<div class="search-results"><div class="search-eyebrow">' + ergebnisse.length + ' ' + esc(tx('treffer')) + '</div>';
          ergebnisse.forEach(function (p) {
            var bild = p.img ? '<div class="ph has-img "><img src="' + esc(window.zctLaden.bildUrl(p.img, 1600)) + '" srcset="' + esc(window.zctLaden.bildSet(p.img)) +
              '" sizes="(max-width: 680px) 92vw, (max-width: 1100px) 48vw, 560px" alt="' + esc(p.name) + '" loading="lazy" decoding="async" referrerpolicy="no-referrer"></div>' : '';
            var unter = (p.monoDe || p.katText || '') + ' ' + (p.preis ? ' · ' + tx('ab') + ' ' + fmt(p.preis / 100) : ' · ' + tx('auf_anfrage_suche'));
            h += '<a href="' + esc(ROOT + '/products/' + encodeURIComponent(p.handle || p.id)) + '" class="search-row"><div class="search-thumb">' + bild + '</div><div class="search-meta"><div class="search-name">' + esc(p.name) +
              '</div><div class="search-sub">' + esc(unter) + '</div></div>' + pfeil() + '</a>';
          });
          h += '</div>';
        }
        koerper.innerHTML = h;
      }
      function sucheSetzen(an) {
        if (an === zustand.suche) return;
        zustand.suche = an;
        if (an && sucheVorlage) {
          ebene = sucheVorlage.content.firstElementChild.cloneNode(true);
          ebene._leer = ebene.querySelector('.search-body').innerHTML;
          menue.after(ebene);
          var feld = ebene.querySelector('.search-top input');
          ebene.addEventListener('click', function () { sucheSetzen(false); menueSetzen(false); });
          ebene.querySelector('.search-panel').addEventListener('click', function (e) {
            e.stopPropagation();
            var t = e.target;
            if (t.closest('.search-top button')) { sucheSetzen(false); menueSetzen(false); return; }
            var tag = t.closest('.search-tag');
            if (tag) { feld.value = tag.textContent; trefferZeichnen(feld.value); return; }
            var a = t.closest('a[href]');
            if (a && e.button === 0 && !(e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)) { sucheSetzen(false); menueSetzen(false); }
          });
          feld.addEventListener('input', function () { trefferZeichnen(feld.value); });
          feld.focus();
          setTimeout(function () { if (feld.isConnected) feld.focus(); }, 50);
        } else if (!an && ebene) {
          wegBlenden(ebene); ebene = null;
        }
        sperre();
      }
      this.addEventListener('click', function (e) {
        var t = e.target;
        if (t.closest && t.closest('[data-zct-suche-auf]')) sucheSetzen(true);
      }, s);
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { sucheSetzen(false); menueSetzen(false); } }, s);

      // ----- Handy-Leiste und Behind-Karten: sieht man, dass es seitlich weitergeht? (Louis' Handy-Figma, wie die Behind-Leiste) -----
      // Verlauf links/rechts und Pfeil (Klassen zd-mehr-links/-rechts, CSS in zct-v26-handy.css), Pfeil scrollt weiter, aktueller Punkt
      // steht beim Laden im Bild, einmal je Besuch kurz anstupsen (WAAPI, 720 ms, nicht bei „Bewegung reduzieren“, Berühren bricht ab).
      var handy = window.matchMedia('(max-width: 1023px)'), ruhig = window.matchMedia('(prefers-reduced-motion: reduce)');
      function weiterHinweis(huelle, scroller, knopf) {
        if (!huelle || !scroller) return null;
        var tick = false, stups = null;
        function lage() {
          var max = scroller.scrollWidth - scroller.clientWidth;
          huelle.classList.toggle('zd-mehr-rechts', handy.matches && scroller.scrollLeft < max - 4);
          huelle.classList.toggle('zd-mehr-links', handy.matches && scroller.scrollLeft > 4);
        }
        scroller.addEventListener('scroll', function () { if (tick) return; tick = true; requestAnimationFrame(function () { tick = false; lage(); }); }, { passive: true, signal: self.ab.signal });
        window.addEventListener('resize', lage, s);
        if (knopf) knopf.addEventListener('click', function (e) { e.preventDefault(); scroller.scrollBy({ left: Math.round(scroller.clientWidth * 0.6), behavior: ruhig.matches ? 'auto' : 'smooth' }); }, s);
        scroller.addEventListener('touchstart', function () { if (stups) stups.cancel(); }, { passive: true, signal: self.ab.signal });
        return {
          lage: lage,
          stupsen: function (schluessel) {
            var gesehen = false; try { gesehen = sessionStorage.getItem(schluessel) === '1'; } catch (e) {}
            var spur = scroller.firstElementChild;
            if (gesehen || !handy.matches || ruhig.matches || !spur || !spur.animate || scroller.scrollLeft > 4 || !huelle.classList.contains('zd-mehr-rechts')) return;
            try { sessionStorage.setItem(schluessel, '1'); } catch (e) {}
            var teile = Array.prototype.slice.call(scroller.children);
            stups = { liste: teile.map(function (t) { return t.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-44px)', offset: 0.5 }, { transform: 'translateX(0)' }], { duration: 720, easing: 'cubic-bezier(0.77,0,0.175,1)' }); }) };
            stups.cancel = function () { stups.liste.forEach(function (a) { a.cancel(); }); };
          }
        };
      }
      var leiste = nav.querySelector('.zd-leiste');
      var leisteHinweis = weiterHinweis(nav.querySelector('.zd-leiste-huelle'), leiste, nav.querySelector('.zd-leiste-weiter'));
      // erst im nächsten Bild messen (kein erzwungenes Layout mitten im Laden), am Rechner gar nicht
      if (leisteHinweis && handy.matches) {
        requestAnimationFrame(function () {
          var aktuell = leiste.querySelector('[aria-current="page"]');
          if (aktuell) { var ar = aktuell.getBoundingClientRect(), lr = leiste.getBoundingClientRect(); if (ar.right > lr.right - 64) leiste.scrollLeft += ar.left - lr.left - (lr.width - ar.width) / 2; }
          leisteHinweis.lage();
        });
        setTimeout(function () { if (!zustand.menue) leisteHinweis.stupsen('zd-leiste-stups'); }, 900);
      }

      pruefen();
    }
    disconnectedCallback() {
      if (this.ab) this.ab.abort();
      clearInterval(this.uhrPruefen);
      clearInterval(this.uhrMessen);
      if (this.roSeite) this.roSeite.disconnect();
      if (this.roNav) this.roNav.disconnect();
      if (this.moKlar) this.moKlar.disconnect();
    }
  }

  if (!customElements.get('zct-ankuendigung')) customElements.define('zct-ankuendigung', ZctAnkuendigung);
  if (!customElements.get('zct-kopf')) customElements.define('zct-kopf', ZctKopf);
})();
